import { centeredMainChildGridClasses } from '@/styles/grid';
import clsx from 'clsx';
import * as React from 'react';
import RoamingCard from './RoamingCard';
import { LargeCardFieldsFragment } from 'types/generated';
import { CountryData, RoamingTab } from './types';
import { motion } from 'framer-motion';

type Props = {
  cards: Record<string, LargeCardFieldsFragment[]>;
  activeTab: RoamingTab | null;
  selectedCountryData: CountryData;
};

const RenderCards = ({ card1, card2 }: { card1: LargeCardFieldsFragment; card2: LargeCardFieldsFragment }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50, height: 0 }}
      animate={{ opacity: 1, y: 0, height: 'auto' }}
      exit={{ opacity: 0, y: -20, height: 0 }}
      className={clsx(centeredMainChildGridClasses, 'gap-y-24')}
    >
      {card1 && <RoamingCard cardData={card1} classes="col-span-full md:col-span-6 md:col-start-2" />}
      {card2 && <RoamingCard cardData={card2} classes="col-span-full md:col-span-4" />}
    </motion.div>
  );
};

const RoamingCards = ({ cards, activeTab, selectedCountryData }: Props) => {
  const CallToAbroadId = 'hringt til útlanda';
  const TravellingAbroadEuropId = 'ferðast til útlanda-1';
  const TravellingAbroadEuropNoRoamingId = 'ferðast til útlanda-2';
  const TravellingAbroadGeneralRoamingId = 'ferðast til útlanda-3';
  const TravellingAbroadNoRoamingId = 'ferðast til útlanda-4';

  if (activeTab === RoamingTab.CallToAbroad && cards[CallToAbroadId]) {
    return <RenderCards card1={cards[CallToAbroadId][0]} card2={cards[CallToAbroadId][1]} />;
  } else if (activeTab === RoamingTab.TravellingAbroad) {
    if (selectedCountryData.roamingCatagory === 1 && cards[TravellingAbroadEuropId]) {
      return <RenderCards card1={cards[TravellingAbroadEuropId][0]} card2={cards[TravellingAbroadEuropId][1]} />;
    } else if (selectedCountryData.roamingCatagory === 2 && cards[TravellingAbroadEuropNoRoamingId]) {
      return (
        <RenderCards
          card1={cards[TravellingAbroadEuropNoRoamingId][0]}
          card2={cards[TravellingAbroadEuropNoRoamingId][1]}
        />
      );
    } else if (selectedCountryData.roamingCatagory === 3 && cards[TravellingAbroadGeneralRoamingId]) {
      return (
        <RenderCards
          card1={cards[TravellingAbroadGeneralRoamingId][0]}
          card2={cards[TravellingAbroadGeneralRoamingId][1]}
        />
      );
    } else if (selectedCountryData.roamingCatagory === 4 && cards[TravellingAbroadNoRoamingId]) {
      return (
        <RenderCards card1={cards[TravellingAbroadNoRoamingId][0]} card2={cards[TravellingAbroadNoRoamingId][1]} />
      );
    }
  }
  return;
};
export default RoamingCards;
